import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { KeywordTableColumnTypes } from '../../../components/muiLegacy/Tables/KeywordTable/KeywordTableColumnPicker/models';
import { KeywordTableState } from '../../../components/muiLegacy/Tables/KeywordTable/logic/useKeywordTableState';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import { TagGroupGq } from '../../../graphql/projects/models/TagGroupGq';

export interface ToggleTagGroupColumnProps {
  keywordTableState: KeywordTableState;
  tagGroup: TagGroupGq;
}

export const ToggleTagGroupColumn: React.FC<ToggleTagGroupColumnProps> = ({
  tagGroup,
  keywordTableState,
}) => {
  const isTagGroupShown = keywordTableState.columnPickerBag.columnState.find(
    (c) => c.type === KeywordTableColumnTypes.TagGroup && c.id === tagGroup.id && !!c.order
  );
  const handleShowTableColumn = () => {
    if (isTagGroupShown) {
      keywordTableState.columnPickerBag.setColumnState((prev) =>
        prev.map((c) => {
          if (c.id === tagGroup.id && c.type === KeywordTableColumnTypes.TagGroup) {
            return { ...c, order: undefined };
          }
          return c;
        })
      );
    } else {
      keywordTableState.columnPickerBag.showTagGroup(tagGroup.id);
      const tagGroupColumn = keywordTableState.columnPickerBag.columnState.find(
        (c) => c.id === tagGroup.id && c.type === KeywordTableColumnTypes.TagGroup
      );
      tagGroupColumn && keywordTableState.scrollToColumn(tagGroupColumn);
    }
  };
  return (
    <VoxelIconButton
      color="white"
      tooltip="Show table column"
      onClick={handleShowTableColumn}
      icon={<FontAwesomeIcon icon={isTagGroupShown ? faEye : faEyeSlash} />}
    />
  );
};

export default ToggleTagGroupColumn;
